<template>
	<div v-if="currentSong && currentSong.content" id="session-detail">
		<div id="session-detail-scroll">
			<h1>{{ currentSong.title }} <small>{{ currentSong.author }}</small></h1>
			<div style="margin-left: -20px">
				<SongContentKytaristka ref="content"
									   :song="currentSong" />
			</div>
			<br><br><br>
		</div>
		<DetailOverlay :current-song="currentSong"
					   is-in-session
					   @transpose="setTranspose($event)"
					   @layout-changed="$refs.content.layoutChanged()" />
	</div>
</template>

<script>
	import { db } from "@/firebase";
	import Vue from "vue";
	import DetailOverlay from "../detail/DetailOverlay";
	import { mapState } from "vuex";
	import SongContentKytaristka from "@/components/detail/SongContentKytaristka";
	import {SongService} from "@/services/SongService";

	export default {
		components: {SongContentKytaristka, DetailOverlay},
		data() {
			return {
				currentSong: null,
			}
		},
		computed: {
			...mapState([ "device" ]),
		},
		mounted() {
			this.$store.commit("setLoadingText", "Čekám na písničku... / I'm waiting for a song");
			db.collection("sessions").where("sessionName", "==", this.$route.params.session).onSnapshot(snapshot => {
				snapshot.docChanges().forEach((change) => {
					var data = change.doc.data();
					if (data.content) {
						this.$store.commit("setLoading", false);
						this.currentSong = data;

						Vue.nextTick(() => {
							this.$el.addEventListener("touchend", this.touchEnd);
							this.$el.addEventListener("mousemove", this.mouseMove);
						});
					}
				});
			});
		},
		destroy() {
			this.$el.removeEventListener("touchend", this.touchEnd);
			this.$el.removeEventListener("mousemove", this.mouseMove);
		},
		methods: {
			setTranspose(value) {
				if (value < 0) {
					if (this.currentSong.transpose-- < -10) {
						this.currentSong.transpose = 0;
					}
				} else {
					if (this.currentSong.transpose++ > 10) {
						this.currentSong.transpose = 0;
					}
				}
			},
			mouseMove() {
				if (this.device && (this.device.platform === "web" || this.device.platform === "desktop-mac" || this.device.platform === "desktop-win")) {
					document.dispatchEvent(new Event("ShowDetailOverlay"));
				}
			},
			touchEnd() {
				document.dispatchEvent(new Event("ShowDetailOverlay"));
			}
		},
		updated() {
			this.$refs.content.processChords();
		}
	}
</script>

<style lang="scss">
	#session-detail {
		margin: 0;
		position: fixed;
		padding: 20px;
		top: 0;
		top: calc(constant(safe-area-inset-top) + 0px);
		top: calc(env(safe-area-inset-top) + 0px);
		left: 0;
		height: calc(100vh - 20px);
		background-color: #eeeeee;
		z-index: -1;

		#session-detail-scroll {
			min-width: 300px;
			height: 100%;
			width: calc(100vw - 20px);
			position: relative;
			overflow-y: auto;
			overflow-x: hidden;
			white-space: normal;
			-webkit-overflow-scrolling: touch;
		}

		h1 {
			font-size: 2em;
			margin: 0;
			padding: 0;

			small {
				opacity: 0.6;
				margin-left: 20px;
			}
		}

		@media only screen and (max-width: 470px) {
			h1 {
				font-size: 1em;
			}
		}

		@media only screen and (max-width: 650px) {
			h1 {
				font-size: 1.4em;
			}
		}
	}
</style>
